import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../theme';

import { Box, Paper, Select, TextareaAutosize,  } from '@material-ui/core';
import {Grid, Typography, FormControl, InputLabel   } from '@material-ui/core';
import {MenuItem, Button} from '@material-ui/core';

import { Navigate } from "react-router-dom";

//export 
class LangUtil_ extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            lang: '',
            json: ''
        }

        this.timer = null

        this.handleAction = this.handleAction.bind(this)
        this.generateLang = this.generateLang.bind(this)
        this.copy = this.copy.bind(this)
    }

    handleAction(action){
        this.props.onAction(action)
    }

    generateLang(){
        //alert('generateLang ' + this.state.lang)

        let sourceLang = 'en'
        let targetLang = this.state.lang

        console.log('../locales/' + sourceLang + '/translation.json')

        let srcJson =  require('../locales/' + sourceLang + '/translation.json')

        let targetJson =  require('../locales/' + targetLang + '/translation.json')

        console.log('generateLang')
        console.log(srcJson)
        console.log(targetJson)

        let targetArray = []

        targetArray.push('{')

        for(var i in srcJson){
            
            console.log(i)

            let isComment = i.charAt(0)==="_" && i.charAt(1)==="_"

            if(isComment) targetArray.push("\n")

            if(targetJson[i]===undefined){
                targetArray.push("    \""+i+"\": \""+srcJson[i]+" (todo)\",")
            }else{
                targetArray.push("    \""+i+"\": \""+targetJson[i]+"\",")
            }

            //if(isComment) targetArray.push("\n")

        }

        targetArray.push('}')

        console.log(targetArray)

        let json = targetArray.join("\n")

        json = json.replace(",\n}", "\n}")

        console.log(json)

        this.setState({json: json})
    }

    handleLangChange(e){
        const lang = e.target.value
        this.props.i18n.changeLanguage(lang);
        this.setState({lang: lang})
    }

    copy(){
        window.navigator.clipboard.writeText(this.state.json)
    }

    render(){

        const {t, i18n} = this.props

        let margin = {margin:10}

        if(this.state.navigate){
            return (
<Navigate to={this.state.navigate}></Navigate>
            )
        }

        let statusMessage = ''
        if(this.props.statusMessage){
            statusMessage = (
            <Typography align="center" color={this.props.statusError ? "error" : "default"}>
                {this.props.statusMessage}
            </Typography>
            );
        }
                            

        return (
            <>
            <Grid item xs={12} style={{height:'100vh', border: '1px solid green',}}>

                <Grid container justify="flex-start" spacing={0} 
                    style={{paddingTop: 5,
                        border2: '1px solid blue',
                        borderTop:'1px solid '+theme.palette.border.dialog}} >


                    <Grid xs={12} key="2" item style={{padding:5}}>

                        <Grid  key="4" container direction="row" spacing={1}  
                            item style={{padding:5, border2: '1px solid red'}}>

                                <Paper style={{width:'100%'}}>
                                    <Box style={margin}>
                                        <Typography>LangUtil</Typography>
                                    </Box>

                                    <Box style={margin} textAlign="left">
                                        <FormControl style={{minWidth: 170}}>
                                            <InputLabel htmlFor="Lang">{t("Language")}</InputLabel>
                                            <Select
                                                style={{textAlign: 'left'}}
                                                value={this.state.lang}
                                                onChange={this.handleLangChange.bind(this)}
                                                inputProps={{name: 'lang', id: 'lang'}}
                                                >
                                                {Object.keys(i18n.options.langs).map(
                                                    code => <MenuItem key={code} value={code}>{i18n.options.langs[code].name}</MenuItem>
                                                )}
                                            </Select>

                                        </FormControl>
                                    </Box>


                                    <Box style={margin} color="secondary">
                                        <Button 
                                            style={{margin:10}}
                                            disabled={this.state.lang===''}
                                            variant="outlined" onClick={this.generateLang} >Generate</Button>

                                        <Button 
                                            style={{margin:10}}
                                            disabled={this.state.json===''}
                                            variant="outlined" onClick={this.copy} >Copy</Button>
                                    </Box>

                                    <Box style={margin}>
                                        <TextareaAutosize 
                                            value={this.state.json} 
                                            style={{width:'100%'}}>
                                        </TextareaAutosize>
                                    </Box>
                            
                                </Paper>
                        </Grid>
                        
                    </Grid>
                </Grid>

                <Grid xs={12} key="5" item style={{border2: '1px solid green', height:'3em'}}>
                    {/*server startus*/} {statusMessage}
                </Grid>

            </Grid>
            </>
        );



    }

}

export const LangUtil = withTranslation()(LangUtil_);